module.exports = __webpack_public_path__ + "img/nav-misconduct.e698096f.svg";